import { configureGlobalStore, setGlobalStore, getGlobalStore } from "@cisco/spaces-dash-lib-redux-store";

// const globalStore = configureGlobalStore({}, []);
// setGlobalStore(globalStore);
// export default globalStore;

// Register App1's reducer and saga with global store

const globalStore = getGlobalStore() ? getGlobalStore() : configureGlobalStore({}, []);
setGlobalStore(globalStore);
export default globalStore;
